<template>
  <v-container fluid="" class="banner">
    <NavBar></NavBar>

    <v-row class="mt-lg-7 d-flex justify-center align-center h-100">
      <v-col
        cols="12"
        lg="6"
        md="6"
        class="d-none d-lg-block d-md-block"
      ></v-col>

      <v-col cols="12" lg="6" md="6" class="d-flex justify-center align-center">
        <div class="login glass-2 pa-5 text-white">
          <div class="py-2">
            <h3 class="fw-bolder">LIFELINE ADMIN</h3>
            <p>Welcome Back Admin</p>
          </div>
          <form @submit.prevent="login">
            <v-text-field
              required
              placeholder="Email"
              type="text"
              density="compact"
              variant="outlined"
              hint="Enter your email"
              v-model.trim="adminLogin.email"
            ></v-text-field>

            <br />

            <v-text-field
              required
              placeholder="Password"
              type="password"
              density="compact"
              variant="outlined"
              name="password"
              hint="Enter Password"
              v-model.trim="adminLogin.password"
            ></v-text-field>

            <p class="text-danger my-0 py-0 fw-bolder" v-if="loginError">
              {{ errorMessage }}
            </p>
            <!-- SUBMIT BUTTON -->

            <v-btn
              block
              append-icon="mdi-send-outline"
              variant="elevated"
              class="mt-3"
              type="submit"
              color="green"
              :loading="wheel"
            >
              Sign In
            </v-btn>

            <div class="d-flex justify-space-between">
              <p class="col">
                <a class="nav-link text-white" href="#">Reset Password</a>
              </p>
              <p class="col">
                <a class="nav-link text-white" href="/apply">Sign-Up</a>
              </p>
            </div>

            <div>
              <v-divider class="my-3"> Or </v-divider>
              <div class="my-lg-3">
                <div class="d-flex justify-center">
                  <v-icon icon="mdi-google"></v-icon>
                  <v-icon icon="mdi-facebook mx-4"></v-icon>
                  <v-icon icon="mdi-twitter"></v-icon>
                </div>
              </div>
            </div>
          </form>
        </div>
      </v-col>
    </v-row>
    <v-sheet></v-sheet>
  </v-container>
</template>

<script>
export default {
  name: "Lifeline Login Page",

  data() {
    return {
      errorMessage: "",
      loginError: false,
      wheel: false,
      adminLogin: {
        email: "",
        password: "",
      },
    };
  },

  methods: {
    async login() {
      const router = useRouter();
      this.wheel = true;
      const email = this.adminLogin.email;
      const password = this.adminLogin.password;

      try {
        const credentials = await signInUser(email, password);
        if (email === "shirazadnan53@gmail.com" || email === "phynogrey2020@gmail.com") {
          router.push("/admin");
          console.log("Login Successful");
        } else {
          this.wheel = false;
          alert("You are not the Admin");
          router.push("/lifeline");
        }
      } catch {
        (error) => {
          this.loginError = true;
          this.wheel = false;
          console.error("Sign-in error:", error.code);
          switch (error.code) {
            case "auth/invalid-email":
              this.errorMessage = "Invalid email";
              break;

            case "auth/user-not-found":
              this.errorMessage = "Email not registered";
              break;

            case "auth/wrong-password":
              this.errorMessage = "Wrong password";
              break;

            case "auth/network-request-failed":
              this.errorMessage = "No internet connection";
              break;

            default:
              this.errorMessage = "Incorrect Email or Password";
              break;
          }
        };
      }
    },
  },
};
</script>

<style scoped>
.banner {
  width: 100%;
  height: 100dvh;
  background-image: linear-gradient(rgba(0, 0, 0, 0.686), rgba(0, 0, 0, 0.541)),
    url(/images/tutor2.jpg);
  object-fit: cover;
  background-size: cover;
  overflow: hidden;
  background-position: center bottom;
  background-repeat: no-repeat;
}

.login {
  max-width: 60%;
  width: 50dvw;
  height: 70dvh;
}

.fa {
  font-size: 1.3rem;
  margin: 0 0.7rem;
}

@media only screen and (max-width: 600px) {
}

@media (max-width: 1028px) {
  .login {
    max-width: 100%;
    width: 80%;
    /* height: 70dvh; */
  }
}
</style>
